import { useQuery } from '@tanstack/react-query';

import { $apiV2 } from 'modules/global';

import { IResult } from '../models';

export const useResult = (ticketId?: string) => {
  const { data, ...args } = useQuery({
    queryKey: ['result-national-certificate', ticketId],
    queryFn: async () => {
      const { data } = await $apiV2.get<{ data: IResult }>(`/nat-certificate/result`, {
        params: { ticket_id: ticketId }
      });

      return { results: data.data };
    }
  });

  return { ...data, ...args };
};
